import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { Tabs } from './Tabs';

const sample: Dictionary<{
  label: string;
  products: string;
  dishes: string;
  archived: string;
}> = {
  pl: {
    label: 'Katalog',
    products: 'Produkty',
    dishes: 'Dania',
    archived: 'Archiwum',
  },
  en: {
    label: 'Catalog',
    products: 'Products',
    dishes: 'Dishes',
    archived: 'Archived',
  },
};

// Every href lands on this page, so following one stays in the catalog; the
// first tab is the one lit, because it matches the current URL.
const HERE = '/library/tabs';

export default {
  kind: 'component',
  title: { pl: 'Zakładki', en: 'Tabs' },
  description: {
    pl: 'Widoki jednej strony, każdy pod własnym adresem — odświeżenie albo link otwiera tę samą zakładkę. Zakładka świeci się, gdy jej `href` to dokładnie bieżąca ścieżka.',
    en: 'Sibling views of one page, each at its own URL, so a reload or a link opens the same tab. A tab is lit when its `href` is exactly the current path.',
  },
  variants: [
    {
      name: { pl: 'Dwie zakładki', en: 'Two tabs' },
      render: (locale) => {
        const t = sample[locale];
        return (
          <Tabs
            label={t.label}
            items={[
              { key: 'products', href: HERE, label: t.products },
              { key: 'dishes', href: `${HERE}#dishes`, label: t.dishes },
            ]}
          />
        );
      },
    },
    {
      name: { pl: 'Trzy zakładki', en: 'Three tabs' },
      render: (locale) => {
        const t = sample[locale];
        return (
          <Tabs
            label={t.label}
            items={[
              { key: 'products', href: HERE, label: t.products },
              { key: 'dishes', href: `${HERE}#dishes`, label: t.dishes },
              { key: 'archived', href: `${HERE}#archived`, label: t.archived },
            ]}
          />
        );
      },
    },
  ],
} satisfies Story;
